/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { kore_url } from "./index";
import { notificationsBodyInterface } from "context/initialState/Notifications";
import saveAs from "file-saver";

export default {
  getList: async (token: string, filter?: string, param?: string) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const paginationParameters = () => {
      let paginationQuery = "";
      if (!filter) {
        paginationQuery = `?${param ? param : ""}`;
      } else if (filter && param) {
        paginationQuery = `&${param ? param : ""}`;
      }
      return paginationQuery;
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notifications${queries()}${paginationParameters()}`,
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios(config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  // TODO: combine these two "Export" functions into one:
  getCSV: async (token: string, filter?: string, userEmail?: string) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notifications${queries()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return await axios(config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getExportPDF: (
    token: string,
    fileName: string,
    filter?: string,
    userEmail?: string
  ) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notifications${queries()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    axios({
      url: config.url,
      headers: config.headers,
      method: "GET",
      responseType: "blob" // Important: This tells axios to expect binary data
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `${fileName}.pdf`);
      })
      .catch((error) => {
        // Handle error if necessary
        console.error("Error while downloading PDF:", error);
      });
  },
  getSingle: async (id: string, token: string) => {
    const config = {
      method: "GET",
      url: kore_url + "/api/v4/notifications/" + id,
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios(config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  create: async (notification: notificationsBodyInterface, token: string) => {
    const config = {
      method: "POST",
      url: kore_url + "/api/v4/notifications",
      data: notification,
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios(config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  update: async (id: string, token: string, changes: object) => {
    const config = {
      method: "PUT",
      url: kore_url + "/api/v4/notifications/" + id,
      data: changes,
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios(config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
  getCount: async (token: string, filter?: string, param?: string) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const paginationParameters = () => {
      let paginationQuery = "";
      if (!filter) {
        paginationQuery = `?${param ? param : ""}`;
      } else if (filter && param) {
        paginationQuery = `&${param ? param : ""}`;
      }
      return paginationQuery;
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notifications/count/${queries()}${paginationParameters()}`,
      headers: { Authorization: `Bearer ${token}` }
    };
    return await axios(config)
      .then((readingList) => {
        return readingList.data;
      })
      .catch((err) => console.log(err));
  },
};

